export const LS_BRAND_DRAFT_KEY = 'admin-brands:draft';
export const LS_BRAND_DRAFT_LOGO_KEY = 'admin-brands:draft-logo';
